import "./Button.css";

const Button = ({
  value,
  onClick = () => {},
  disabled = false,
  isActive,
  isWarning = false,
  isAlert = false,
  className = "",
}) => {
  return (
    <button
      type="button"
      className={`App-button App-text-medium  ${isActive ? "active" : ""} ${
        isWarning ? "warning" : ""
      } ${isAlert ? "alert" : ""} ${className}`}
      disabled={disabled}
      onClick={onClick}
    >
      {value}
    </button>
  );
};

export default Button;
